import { EServicesErrorCode } from 'core/model/enums/error-code.enum';
import { Path } from './path.constants';

export const LAYOUT_ERRORS_CODES = {
  [EServicesErrorCode.REDIRECT_TO_MAINTENANCE]: { redirect: Path.MAINTENANCE },
  [EServicesErrorCode.LOGGED_IN_NO_PERMISSIONS]: {
    redirect: Path.AUTOPROSPECT_SUCCESS,
  },
};
